import {client} from '../axios';

import {User} from "@/types/UserType";
import {ResponseError} from "@/types";
import {resolveError} from "@/data/_resolveError";

export const login = (
    email: string,
    password: string,
    success = (token: string, user: User) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/auth/login`, {email, password})
        .then(({data}: any) => {
            const token = data.data.token;

            const user = data.data.user;

            success(token, user);
        }).catch((error) => resolveError(error, failed));
};

export const loginByProvider = (
    provider: string,
    success: (redirect_url: string, provider: string) => void,
    failed = (type: ResponseError, data: any) => {
    }
) => {
    client.get(`/auth/login/social/${provider}`)
        .then(({data}: any) => {
            success(data.data.redirect_url, data.data.provider);
        }).catch((error) => resolveError(error, failed));
};

export const socialProviderCallback = (
    provider: string,
    query: {},
    success = (token: string, user: User) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    const queryString = new URLSearchParams(query).toString();

    client.post(`/auth/login/social/${provider}/callback?${queryString}`)
        .then(({data}: any) => {
            const token = data.data.token;

            const user = data.data.user;

            success(token, user);
        }).catch((error) => resolveError(error, failed));
}

export const register = (
    email: string,
    password: string,
    name: string,
    success = (token: string, user: User) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/auth/register`, {
        email,
        password,
        password_confirmation: password,
        name
    })
        .then(({data}: any) => {
            const token = data.data.token;

            const user = data.data.user;

            success(token, user);
        }).catch((error) => resolveError(error, failed));
};

export const logout = (
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/auth/logout`)
        .then(() => {
            success();
        }).catch((error) => resolveError(error, failed));
};